import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Order from 'src/smoothr-web-app-core/models/Order';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import Venue from 'src/smoothr-web-app-core/models/Venue';

@Component({
	selector: 'app-promocode-buyed-by-points',
	templateUrl: './promocode-buyed-by-points.component.html',
	styleUrls: ['./promocode-buyed-by-points.component.scss'],
})
export class PromocodeBuyedByPointsComponent implements OnInit {
	@Input() order: Order;
	@Input() venue: Venue;
	@Input() promoCode: PromoCode;
	@Input() amountOfPoints: number = 0;
	@Output() selectPromoCode = new EventEmitter<PromoCode>();
	constructor() {}

	ngOnInit() {}
	addLoyaltyItem(item: PromoCode) {
		this.selectPromoCode.emit(item);
	}
	calculateValue(promoCode: PromoCode) {
		return promoCode.piggyReward.required_credits / this.amountOfPoints;
	}
}
